import { render } from "./PatientDocuments.vue?vue&type=template&id=7f990242&ts=true"
import script from "./PatientDocuments.ts?vue&type=script&lang=ts&external"
export * from "./PatientDocuments.ts?vue&type=script&lang=ts&external"

import "./PatientDocuments.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__